import { Component, inject } from '@angular/core';
import { RedemptionService } from '../../core/services/redemption.service';
import { RedemptionsComponent } from '../../components/redemptions/redemptions.component';
import { BarReaderComponent } from '../../components/bar-reader/bar-reader.component';
import { MatFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-reader',
  imports: [
    RedemptionsComponent,
    BarReaderComponent,
    MatFabButton,
    MatIcon,
    RouterLink,
  ],
  templateUrl: './reader.component.html',
  styleUrl: './reader.component.scss',
})
export class ReaderComponent {
  private redemptionService = inject(RedemptionService);
}
